const communities = [
  { name: "Eagle River", zip: "99577" },
  { name: "Wasilla", zip: "99654" },
  { name: "Palmer", zip: "99645" },
  { name: "Chugiak", zip: "99567" },
  { name: "Girdwood", zip: "99587" },
  { name: "Birchwood", zip: "99502" },
  { name: "Elmendorf AFB", zip: "99506" },
  { name: "Joint Base Elmendorf-Richardson", zip: "99505" },
  { name: "Muldoon", zip: "99504" },
  { name: "Midtown Anchorage", zip: "99503" },
  { name: "South Anchorage", zip: "99515" },
  { name: "Hillside", zip: "99507" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Anchorage &amp; All of Southcentral Alaska
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center serves the entire Anchorage metro area including the Municipality of Anchorage, the Mat-Su Borough, and surrounding communities. Alaska residents can ship their documents to our registered office for expedited passport processing — no Seattle or Denver agency trip required.
            </p>
            <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Nearest Passport Agency</h3>
              <p className="text-gray-600 text-sm mb-2">
                <strong>Seattle Passport Agency</strong> — 915 2nd Ave, Seattle, WA 98174
              </p>
              <p className="text-gray-500 text-sm mb-2">
                Distance from Anchorage: 1,400+ miles. Flight required, plus same-day appointment.
              </p>
              <p className="text-gray-500 text-sm">
                Fast Passport Center eliminates this trip entirely.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-5">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Alaska Coverage</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We process passports for residents throughout Anchorage (99501–99524), Eagle River, Wasilla, Palmer, the Mat-Su Valley, and all of Southcentral Alaska. Military families at JBER and Elmendorf AFB are also served.
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-[#1A365D] mb-5">Communities We Serve</h3>
            <div className="grid grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="bg-white border border-gray-200 rounded-lg px-4 py-3 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-[#F6C344] text-sm"></i>
                    </div>
                    <span className="text-sm font-semibold text-[#1A365D]">{c.name}</span>
                  </div>
                  <span className="text-xs text-gray-400">{c.zip}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}